import React, { useState } from 'react'
import { Form, Alert } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import WashJobsTable from './Jobs/WashJobsTable'
import ControlJobsTable from './Jobs/ControlJobsTable'
import RepairJobsTable from './Jobs/RepairJobsTable'
import CloseRepairJob from './Jobs/CloseRepairJob'
import CloseControlJob from './Jobs/CloseControlJob'
import instMgmtApi from '../../utils/api/instanceMgmt/instMgmtApi'
import ScanList from './ScanList'
import ScanCode from './ScanCode'
import { inject, observer } from 'mobx-react'
import { withTranslation } from 'react-i18next'
import styled from 'styled-components'
const StyledSwitch = styled.div`
  font-weight: bold;
  display: flex;
  flex-direction: row-reverse;
`

const JobScan = (props) => {
    const { t, washStore } = props
    const [scanCodeObj, setScanCodeObj] = useState(null);
    const [scanCodeObjs, setScanCodeObjs] = useState([]);
    const [showOpenJobs, setShowOpenJobs] = useState(false)

    const createWashJob = async (obj) => {
        const { rfid, hasWashJob } = obj
        if (hasWashJob) {
            updateScanCodeObjs(obj)
            return true;
        }
        let params = {
            action: "washService",
            stationId: washStore.selectedWashStationId,
        }
        await instMgmtApi.postScanCodeAction(rfid, params)
        washStore.loadOpenWashItemsCounter()
        let result = await instMgmtApi.getScanCodeInfo(rfid)
        result.wasAlreadyScaned = false
        updateScanCodeObjs(result);
    }

    const handleCloseJob = (closed) => {
        setScanCodeObj(null)
    }
    const handleOnChangeSwitch = (e) => {
        setShowOpenJobs(e.target.checked)
    }
    const showScanlist = () => {
        return washStore.checkIsWashStation()
    }
    const addScanCodeObj = (obj) => {
        setScanCodeObj(obj)
        if (showScanlist() && obj && obj.isValid) {
            if (washStore.checkIsWashStation()) {
                createWashJob(obj)
            }
            else {
                updateScanCodeObjs(obj)
            }
        }
    }
    const updateScanCodeObjs = (obj) => {
        if (showScanlist() && obj && obj.isValid) {
            let scans = [...scanCodeObjs]
            scans.push(obj)
            setScanCodeObjs(scans)
            setScanCodeObj(null)
        }
    }
    const renderSwitch = (
        <>
            <StyledSwitch>
                <Form.Check
                    type="switch"
                    id="job-switch"
                    label={washStore.checkIsWashStation() ? `${washStore.openWashItemsCount} ${t('washPage:billingOpenWashItems')}` : t('washPage:openJobs')}
                    onChange={handleOnChangeSwitch}
                    checked={showOpenJobs}
                />
            </StyledSwitch>
        </>
    )
    const renderInputRFID = (
        <>
            <ScanCode scanCodeObj={scanCodeObj} setScanCodeObj={addScanCodeObj} />
        </>
    )
    const renderScanlist = (
        <>
            <div className="mb-5" />
            <div className="mb-5" >
                <ScanList scanItems={scanCodeObjs} setScanItems={setScanCodeObjs} />
            </div>
        </>
    )
    const createErrorCode = () => {
        if (showOpenJobs) return null
        if (scanCodeObj && !scanCodeObj.isValid) {
            return (
                <Alert
                    style={{ wordBreak: "break-all" }}
                    variant="danger"
                >
                    <Link to={`/wash#recapturing`}>
                        <div className='bubble-wrapper'>
                            {t('washPage:invalid')} {t('washPage:askForRecapturing')}
                        </div>
                    </Link>
                </Alert>
            )
        }
    }
    return (
        <>
            <h2>{t('washPage:main')} - {washStore.washStation?.displayName ?? ''}</h2>
            {scanCodeObj?.isValid ? null : renderSwitch}
            {((scanCodeObj?.isValid && !showScanlist()) || showOpenJobs) ? null : renderInputRFID}
            {(washStore.checkIsWashStation() && showOpenJobs) && <WashJobsTable stationId={washStore.selectedWashStationId}/>}
            {(washStore.checkIsControlStation() && showOpenJobs) && <ControlJobsTable stationId={washStore.selectedWashStationId} disabledDisposal={!washStore.checkWashActionIsAllowed('disposed')}/>}
            {(washStore.checkIsControlStation() && !showOpenJobs && scanCodeObj?.isValid) && <CloseControlJob scanCodeObj={scanCodeObj} setScanCodeObj={setScanCodeObj} handleClose={handleCloseJob} />}
            {(washStore.checkIsRepairStation() && showOpenJobs) && <RepairJobsTable stationId={washStore.selectedWashStationId} disabledDisposal={!washStore.checkWashActionIsAllowed('disposed')}/>}
            {(washStore.checkIsRepairStation() && !showOpenJobs && scanCodeObj?.isValid) && <CloseRepairJob scanCodeObj={scanCodeObj} setScanCodeObj={setScanCodeObj} handleClose={handleCloseJob} />}
            {createErrorCode()}
            {(showScanlist() && !showOpenJobs) ? renderScanlist : null}
        </>
    )
}

export default withTranslation()(
    inject(
        'washStore',
    )(observer(JobScan))
)
